/**
 * Datas/horas — fuso de Brasília (GMT-3), sem horário de verão.
 *
 * Regra do projeto: o banco guarda carimbos em UTC. Alguns registros ANTIGOS
 * foram gravados pelo SQLite (`CURRENT_TIMESTAMP`) como UTC **sem fuso** (naive),
 * e chegam ao front como "2026-09-07T20:00:00" (sem `Z`/offset). O `new Date()`
 * do navegador interpretaria isso como hora LOCAL, adiantando o relógio.
 *
 * `paraData` resolve isso: se a string NÃO tem fuso (nem `Z`, nem `+hh:mm`),
 * tratamos como UTC. Datas já "aware" (com offset) passam intactas. Depois
 * formatamos SEMPRE em America/Sao_Paulo, valha desktop ou servidor.
 */

const TEM_FUSO = /(?:Z|[+-]\d{2}:?\d{2})$/;

/** Converte um ISO do backend em Date, tratando strings sem fuso como UTC. */
export function paraData(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const s = TEM_FUSO.test(iso) ? iso : `${iso}Z`;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

const TZ = "America/Sao_Paulo";

/** "07/09/2026 17:00" no fuso de Brasília. Vazio → "—". */
export function fmtDataHora(iso: string | null | undefined): string {
  const d = paraData(iso);
  if (!d) return "—";
  return d.toLocaleString("pt-BR", {
    timeZone: TZ,
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

/** "07/09/2026" no fuso de Brasília. Vazio → "—". */
export function fmtData(iso: string | null | undefined): string {
  const d = paraData(iso);
  if (!d) return "—";
  return d.toLocaleDateString("pt-BR", {
    timeZone: TZ,
    day: "2-digit", month: "2-digit", year: "numeric",
  });
}
